// extracted by mini-css-extract-plugin
export default {"wrapperMenu":"AgreementPriceListUer_wrapperMenu__IWU30"};